/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createThread = /* GraphQL */ `
  mutation CreateThread(
    $input: CreateThreadInput!
    $condition: ModelThreadConditionInput
  ) {
    createThread(input: $input, condition: $condition) {
      id
      name
      messages {
        items {
          id
          threadId
          senderId
          content
          createdOn
          updatedOn
          owner
          __typename
        }
        nextToken
        __typename
      }
      userId
      lastMessageSentAt
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateThread = /* GraphQL */ `
  mutation UpdateThread(
    $input: UpdateThreadInput!
    $condition: ModelThreadConditionInput
  ) {
    updateThread(input: $input, condition: $condition) {
      id
      name
      messages {
        items {
          id
          threadId
          senderId
          content
          createdOn
          updatedOn
          owner
          __typename
        }
        nextToken
        __typename
      }
      userId
      lastMessageSentAt
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteThread = /* GraphQL */ `
  mutation DeleteThread(
    $input: DeleteThreadInput!
    $condition: ModelThreadConditionInput
  ) {
    deleteThread(input: $input, condition: $condition) {
      id
      name
      messages {
        items {
          id
          threadId
          senderId
          content
          createdOn
          updatedOn
          owner
          __typename
        }
        nextToken
        __typename
      }
      userId
      lastMessageSentAt
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createMessage = /* GraphQL */ `
  mutation CreateMessage(
    $input: CreateMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    createMessage(input: $input, condition: $condition) {
      id
      threadId
      senderId
      content
      createdOn
      updatedOn
      owner
      __typename
    }
  }
`;
export const updateMessage = /* GraphQL */ `
  mutation UpdateMessage(
    $input: UpdateMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    updateMessage(input: $input, condition: $condition) {
      id
      threadId
      senderId
      content
      createdOn
      updatedOn
      owner
      __typename
    }
  }
`;
export const deleteMessage = /* GraphQL */ `
  mutation DeleteMessage(
    $input: DeleteMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    deleteMessage(input: $input, condition: $condition) {
      id
      threadId
      senderId
      content
      createdOn
      updatedOn
      owner
      __typename
    }
  }
`;
